import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo/seo"
import styled from "styled-components"

import PageHeader from "../components/pageHeader/PageHeader"
import TopPart from "../pagesParts/history/TopPart"
import MidPart from "../pagesParts/history/MidPart"
import BotPart from "../pagesParts/history/BotPart"

const StyledMainWrapper = styled.main`
  margin-top: 120px;
`

export default function HistoryPage() {
  return (
    <Layout>
      <SEO
        title="Our History"
        description="Origin Restaurant is a new and well-known spot in Ethiopia for flavorful chaofan, juicy steak sandwiches, classic hotdogs, crispy fries, and ice-cold drinks."
      />
      <StyledMainWrapper>
        <PageHeader
          heading="Our History"
          subheading="Origin Restaurant is a new and well-known spot in Ethiopia — built around big flavor, fast service, and food you’ll crave again." 
        />
        <TopPart />
        <MidPart />
        <BotPart />
      </StyledMainWrapper>
    </Layout>
  )
}
